import React, { FC, useEffect, useState } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import StartRating from "components/StartRating/StartRating";
import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
import Badge from "shared/Badge/Badge";
import { v4 as uuidv4 } from "uuid";
import { Listing } from "Types/Listing";
import { adItems } from "components/Modals/PropertyPostModal";
export interface StayCardHProps {
  className?: string;
  data: Listing;
  isLoaded?: boolean;
}

const StayCardH: FC<StayCardHProps> = ({ className = "", data, isLoaded }) => {
  const {
    galleryImgs,
    guestCount,
    roomCount,
    bathroomCount,
    bedCount,
    listingCat,
    address,
    categorySlug,
    name,
    price,
    pricePerNight,
    id,
    priceUnit,
    sizeUnit,
    size,
    packageId,
    city,
  } = data;
  const adItem = adItems.find((item) => item.id === packageId);
  const renderSliderGallery = () => {
    return (
      <div className="relative flex-shrink-0 w-full md:w-72">
        <GallerySlider
          ratioClass="aspect-w-6 aspect-h-5 "
          galleryImgs={galleryImgs}
          uniqueID={`StayCardH_${id}`}
          href={`/listings/${id}`}
        />
        {/* <BtnLikeIcon isLiked={like} className="absolute right-3 top-3" /> */}
        {/* {true && <SaleOffBadge className="absolute left-3 top-3" />} */}
      </div>
    );
  };

  const renderTienIch = () => {
    return (
      <div className="hidden sm:grid grid-cols-3 gap-2">
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <i className="las la-user text-lg"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {guestCount} guests
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="las la-bed text-lg"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">{bedCount} beds</span>
          </div>
        </div>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <i className="las la-bath text-lg"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {bathroomCount} baths
            </span>
          </div>
          {/* <div className="flex items-center space-x-3">
            <i className="las la-smoking-ban text-lg"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">No smoking</span>
          </div> */}
        </div>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <i className="las la-door-open text-lg"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {roomCount} bedrooms
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className="las la-expand-arrows-alt text-2xl"></i>
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {size} {sizeUnit}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    const parsedCity = city as unknown as string;

    return (
      <div className="flex-grow p-3 sm:p-5 flex flex-col">
        <div className="space-y-2">
          <div className="text-sm text-neutral-500 dark:text-neutral-400">
            <span>
              {listingCat} in {address}, {parsedCity}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            {adItem?.name && adItem.id !== "free" && (
              <Badge name={adItem?.name} color={adItem.badgeColor} />
            )}
            <h2 className="text-lg font-medium capitalize">
              <span className="line-clamp-1">{name}</span>
            </h2>
          </div>
        </div>
        <div className="hidden sm:block w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        {renderTienIch()}
        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        <div className="flex justify-between items-end">
          {/* <StartRating reviewCount={reviewCount} point={reviewStart} /> */}
          <div className="flex flex-col">
            <span className="text-base font-semibold text-secondary-500">
              From {pricePerNight} {priceUnit == "USD" ? "$" : "€"}
              {` `}
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                / per night
              </span>
            </span>
            <span className="text-base font-semibold text-secondary-500">
              From {price.toLocaleString()} {priceUnit == "USD" ? "$" : "€"}
              {` `}
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                / property
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  return !isLoaded ? (
    <div
      className={`nc-StayCardH  group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow will-change-transform ${className} animate-pulse`}
      data-nc-id="StayCardH"
    >
      <div className="grid grid-cols-1 md:flex md:flex-row invisible">
        {renderSliderGallery()}
        {renderContent()}
      </div>
    </div>
  ) : (
    <div
      className={`nc-StayCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow will-change-transform  ${className} animate-appear`}
      data-nc-id="StayCardH"
    >
      <Link to={`/listings/${id}`} className="absolute inset-0"></Link>
      <div className="grid grid-cols-1 md:flex md:flex-row">
        {renderSliderGallery()}
        {renderContent()}
      </div>
    </div>
  );
};

export default StayCardH;
